import { useQuery } from '@apollo/client';
import { HASURA_DISCOVER_SEASONS } from '@rivallapp/shared/discover/filters';
import type { FC } from 'react';

import { withPropsFromUrl } from './utils';
import { FilterSelect } from '../../components';
import { filtersWhereClause, type SharedFilterProps, type WithPropsFromUrl } from './types';

const SeasonFilter: FC<WithPropsFromUrl & SharedFilterProps> = props => {
  const {
    disabled = false,
    onSelect,
    isMulti = false,
    className = '',
    updateSearchUrls,
    seasonNames = [],
  } = props;

  const { data } = useQuery(HASURA_DISCOVER_SEASONS, {
    fetchPolicy: 'cache-and-network',
    variables: {
      where: filtersWhereClause(props, {
        seasons: false,
      }),
    },
  });

  const { leagues = [] } = data ?? {};

  const seasonOptions = leagues
    .toSorted((a, b) => a.season.order - b.season.order)
    .map(({ season }) => ({
      label: season.name,
      value: season._id,
    }));

  const onChange =
    typeof onSelect === 'function'
      ? onSelect
      : (v: { label: string; value: string }[]) =>
          updateSearchUrls({ seasonNames: v.map(({ label }) => label) });

  return (
    <FilterSelect
      short
      shadow
      labelSingular="Season"
      labelPlural="Seasons"
      options={seasonOptions}
      value={seasonOptions.filter(({ label }) => seasonNames.includes(label)) || null}
      onChange={onChange}
      disabled={disabled}
      multi={isMulti}
      className={className}
    />
  );
};

export default withPropsFromUrl()(SeasonFilter);
